import { render, staticRenderFns } from "./TollView.vue?vue&type=template&id=20390004&scoped=true&"
import script from "./TollView.vue?vue&type=script&lang=js&"
export * from "./TollView.vue?vue&type=script&lang=js&"
import style0 from "./TollView.vue?vue&type=style&index=0&id=20390004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20390004",
  null
  
)

export default component.exports